import {RequestMessage} from '@crealogix-map/core';

export const closeBrowserMessageTag = 'CloseBrowserMessage';

/**
 * Request the browser to close itself. Only browsers which are allowing the close button will be closed by this message.
 */
export class CloseBrowserMessage extends RequestMessage {
  readonly tag: string = closeBrowserMessageTag;
}



// WEBPACK FOOTER //
// /Users/zasa/map/map-core-git/~/tslint-loader??ref--0-1!./src/Browser/CloseBrowserMessage.ts